import { BASE_PPI, SAFETY_MARGIN_OBJECT_NAME } from './SheetCanvas'
import { placedObjectGeometry } from './placedObjectGeometry'

function ensureObjectId(obj) {
  if (!obj.objectId) obj.objectId = crypto.randomUUID()
  return obj.objectId
}

export function getPlacedObjectSizeInches(obj) {
  if (!obj?.width || !obj?.height) return null
  const geometry = placedObjectGeometry(obj)

  return {
    widthIn: (geometry.width * (geometry.scaleX ?? 1)) / BASE_PPI,
    heightIn: (geometry.height * (geometry.scaleY ?? 1)) / BASE_PPI,
  }
}

export function getPlacedItems(canvas) {
  return canvas.getObjects()
    .filter(obj => obj.name !== SAFETY_MARGIN_OBJECT_NAME)
    .map((obj, index) => {
      const geometry = placedObjectGeometry(obj)
      const size = getPlacedObjectSizeInches(geometry)

      return {
        instance_id:       ensureObjectId(obj),
        uploaded_image_id: parseInt(obj.uploadedImageId, 10),
        x_in:          geometry.left / BASE_PPI,
        y_in:          geometry.top  / BASE_PPI,
        width_in:      size?.widthIn,
        height_in:     size?.heightIn,
        // Kept for schema compatibility. Every serialized item is one physical copy.
        quantity:      1,
        rotation_deg:  geometry.angle,
        flip_x:        geometry.flipX || false,
        flip_y:        geometry.flipY || false,
        z_index:       index,
      }
    })
}

export function serializeLayout(sheets, sheetSize, canvasRefs) {
  return {
    schema_version: 1,
    sheet_size_id:  sheetSize.id,
    sheets: sheets.map((sheet, i) => ({
      sheet_number: i + 1,
      width_in:     sheet.width_in ?? sheetSize.width_in,
      height_in:    sheet.height_in ?? sheetSize.height_in,
      items:        canvasRefs[sheet.id] ? getPlacedItems(canvasRefs[sheet.id]) : [],
    }))
  }
}
